<template>
	<Container>
		<TopBar class="tabbr"/>
		<h2 v-if='article.Title' class="article-title">{{article.Title}}</h2>
		<div v-if='article.MediaType != "video"' class="content" v-html='article.Content'></div>
		<div class="video" v-else>
			<iframe  :src='"https://player.youku.com/embed/"+article.Link + "?client_id=006644816334a836"' style="width: 100%;height:100%"   frameborder=0 allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"></iframe>
		</div>
		
	</Container>
</template>

<script>
	import TopBar from '@/components/common/TopBar'
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				article:{},
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{
			'$route'(value){
				this.initData()
			},
		},
		mixins:[],
		components: {
			TopBar
		},
		computed: {
			...mapState({

			}),
		},
		methods: {
			...mapActions([
				'getCommunityArticleAction',
			]),
			async initData(){
				let Code = this.$route.query?.code
				this.article = await this.getCommunityArticleAction({Code})
			},
		},
	}
</script>

<style lang='scss' scoped>
	.article-title {
		max-width: 1200px;
		margin: auto;
		padding: 20px 0;
		width: 80vw;
		border-bottom: 1px solid #ccc;
	}
	.content {
		max-width: 1200px;
		width: 80vw;
		margin:auto;
	}
	.video {
		margin:30px auto;
		max-width: 1044px;
		max-height: 587px;
		width:80vw;
		height:45vw;
	}
	@media (min-width:1200px ) {
		.tabbr {
			padding-left: calc(50% - 600px)
		}
	}
</style>